import { useQuery } from 'react-query';

import { categoriesToOptionsConverter } from '../../../utils/categoriesToOptionsConverter';

import { getDutyCalculationCodes } from 'RestAPIs/dutyHourTypes';

import { Option } from 'components/shared/ControlledFields/ControlledSelect';

export const useGetDccOptions = () =>
  useQuery<Option[]>({
    queryKey: ['dutyCalculationCodes', 'options'],
    queryFn: async () =>
      await getDutyCalculationCodes().then(
        categoriesToOptionsConverter({
          getLabel: (option) => `${option.dccId} - ${option.description}`,
          getValue: (option) => option.dccId
        })
      ),
    staleTime: Infinity
  });
